module.exports = __webpack_public_path__ + "static/media/34.6e44c8f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/34.png
// module id = 817
// module chunks = 0